<template>
  <div class="ce-searchField">
    <input
      :placeholder="placeholder"
      type="text"
      name="term"
      v-model="term"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      @keydown.enter="enter">

    <div
      v-if="$slots.description"
      class="ms-2 mt2 pl2">
      <slot name="description" />
    </div>

    <button
      type="submit"
      @click="search">
      <fa-icon :icon="['fas', 'search']" />
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    placeholder: {
      type: String,
      required: false,
      default() {
        return this.$t('generic.search');
      }
    }
  },
  data() {
    return {
      term: null
    };
  },
  mounted() {
    if (this.activeSearchTerm && this.activeSearchTerm !== this.term) {
      this.term = this.activeSearchTerm;
    }
  },
  watch: {
    activeSearchTerm(newValue) {
      if (newValue !== this.term) {
        this.term = newValue;
      }
    }
  },
  computed: {
    ...mapGetters(['urlFilters']),
    activeSearchTerm() {
      return this.urlFilters && this.urlFilters.q ? this.urlFilters.q : null;
    }
  },
  methods: {
    search() {
      const q = this.term && this.term.length > 2 ? this.term : null;

      const filters = this.$cloneObject(this.urlFilters);

      // No query given, and also no query filter active, so no change
      if (!q && !filters.q) return;

      // Query is the same as the active query filter, so no change
      if (q && filters.q && q === filters.q) return;

      if (!q) delete filters.q;
      else filters.q = q;

      this.$store.dispatch('setUrlFilters', filters);
    },
    enter() {
      this.search();
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';
@import '~styles/includes/search-field.less';
</style>
